/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Vimeo_Url_LabelInputs */

const en_new_project_vimeo_url_label = /** @type {(inputs: New_Project_Vimeo_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo Page URL`)
};

const fr_new_project_vimeo_url_label = /** @type {(inputs: New_Project_Vimeo_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de la page Vimeo`)
};

const de_new_project_vimeo_url_label = /** @type {(inputs: New_Project_Vimeo_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo-Seiten-URL`)
};

const it_new_project_vimeo_url_label = /** @type {(inputs: New_Project_Vimeo_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL della pagina Vimeo`)
};

const ru_new_project_vimeo_url_label = /** @type {(inputs: New_Project_Vimeo_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL страницы Vimeo`)
};

const es_new_project_vimeo_url_label = /** @type {(inputs: New_Project_Vimeo_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de la página de Vimeo`)
};

const zh_cn2_new_project_vimeo_url_label = /** @type {(inputs: New_Project_Vimeo_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo 页面网址`)
};

const ja_new_project_vimeo_url_label = /** @type {(inputs: New_Project_Vimeo_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VimeoページのURL`)
};

const hi_new_project_vimeo_url_label = /** @type {(inputs: New_Project_Vimeo_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vimeo पेज URL`)
};

const pt_pt2_new_project_vimeo_url_label = /** @type {(inputs: New_Project_Vimeo_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL da página do Vimeo`)
};

/**
* | output |
* | --- |
* | "Vimeo Page URL" |
*
* @param {New_Project_Vimeo_Url_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_vimeo_url_label = /** @type {((inputs?: New_Project_Vimeo_Url_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Vimeo_Url_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_vimeo_url_label(inputs)
	if (locale === "de") return de_new_project_vimeo_url_label(inputs)
	if (locale === "it") return it_new_project_vimeo_url_label(inputs)
	if (locale === "ru") return ru_new_project_vimeo_url_label(inputs)
	if (locale === "es") return es_new_project_vimeo_url_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_vimeo_url_label(inputs)
	if (locale === "ja") return ja_new_project_vimeo_url_label(inputs)
	if (locale === "hi") return hi_new_project_vimeo_url_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_vimeo_url_label(inputs)
	return en_new_project_vimeo_url_label(inputs)
});